import { E as EmblaCarousel } from './embla-carousel.esm-CCUHK2kO.js';
import { a as addScrollBarListener } from './scrollbar-DHAl7Frv.js';
import { a as addPrevNextButtonClickHandlers } from './arrow-buttons-CY1f9syu.js';

class FeaturedBlogSlider extends HTMLElement {
  /** @type {import('embla-carousel').EmblaCarouselType} */
  #embla;

  connectedCallback() {
    const viewport = this.querySelector('.embla__viewport');

    this.#embla = EmblaCarousel(viewport, {
      align: 'start',
      containScroll: 'trim',
      dragFree: true,
      skipSnaps: true,
      slidesToShow: 1.2,
      direction: document.dir,
      breakpoints: {
        '(min-width: 768px)': {
          slidesToShow: 4,
        },
      },
    });

    const scrollbar = this.querySelector('.embla__scrollbar');
    if (scrollbar) addScrollBarListener(this.#embla, scrollbar);

    const prevBtn = this.querySelector('.embla-button--prev');
    const nextBtn = this.querySelector('.embla-button--next');
    if (prevBtn && nextBtn) addPrevNextButtonClickHandlers(this.#embla, prevBtn, nextBtn);
  }
}

customElements.define('featured-blog', FeaturedBlogSlider);
